import { useState, useEffect } from 'react';
import ReportsView from './ReportsView';
import useUniversalStore from 'store/universalStore';
import useOffcanvasStore from 'store/offcanvasStore';
import { sendWAReminder } from 'utils';
import { formatMoney } from 'utils';
import { reminderAPI } from 'services';
import dayjs from 'dayjs';

const Footer = ({ account }) => {
    const [reportLoading, setReportLoading] = useState({ pdf: false, excel: false });
    const {isSharedAccount} = useUniversalStore(store=>store)
    const { openOffcanvas } = useOffcanvasStore((state) => state);
    const reminder = account?.get("reminder");

    const scheduleReminder = () => {
        openOffcanvas("reminder");
    }

    const recursiveTxns = () => {
        openOffcanvas("recursiveTxns");
    }

    if (!account) return null;

    return (
        <div className="position-md-sticky position-fixed bottom-0 w-100 py-2 px-2 px-md-3 border-top bg-light">
            <div className="row g-0 align-items-center">
                <div className="col-7">
                    <span className="fs-5 fs-md-3 d-flex align-items-center justify-content-start">
                        Balance :
                        <span className="ms-1 ms-md-4 fs-6 fs-md-5">{formatMoney(isSharedAccount ? (account?.get("balance")*-1) :account.get("balance"))}</span>
                    </span>
                </div>
                <div className="col-5">
                    <div className="d-flex justify-content-end gap-2 gap-md-3">
                        {!isSharedAccount && <>
                            <div className="btn btn-sm p-0 position-relative"
                            onClick={scheduleReminder}>
                            <i className="bi bi-alarm fs-2 text-app" />
                            {reminder && <span className="position-absolute py-1 px-2 top-0 start-100 translate-middle badge bg-app-light fs-6 rounded-pill">1</span>}
                        </div>

                        <div className="btn btn-sm p-0"
                            onClick={recursiveTxns}>
                            <i className="bi bi-arrow-repeat fs-2 text-app" />
                        </div>
                        </>
                        }

                        <div className="dropdown p-0">
                            <div className="btn btn-sm p-0"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                {reportLoading.pdf ?
                                    <span className="spinner-border text-app" style={{ width: '1.5rem', height: '1.5rem' }} role="status" aria-hidden="true" />
                                    : <i className="bi bi-file-pdf fs-2 text-app" />
                                }
                            </div>
                            <ReportsView setReportLoading={setReportLoading} type="pdf" />
                        </div>

                        <div className="dropdown p-0">
                            <div className="btn btn-sm p-0"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                {reportLoading.excel ?
                                    <span className="spinner-border text-app" style={{ width: '1.5rem', height: '1.5rem' }} role="status" aria-hidden="true" />
                                    : <i className="bi bi-filetype-xls fs-2 text-app" />
                                }
                            </div>
                            <ReportsView setReportLoading={setReportLoading} type="excel" />
                        </div>

                        {!isSharedAccount && <div className="btn btn-sm p-0"
                            title="Remind" onClick={() => sendWAReminder(account)}>
                            <i className="bi bi-whatsapp fs-2 text-app" />
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;